import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter,
  Form, FormGroup, Label, Input, InputGroup, InputGroupAddon } from 'reactstrap'
import {Link} from 'react-router-dom'
import { updateInlineImage } from './ImageUtils'

class ImageModal extends Component {
  constructor (props) {
    super(props)

    const { node } = this.props

    this.state = {
      imageAttributes: {
        fileId: node.data.get('fileId'),
        maxWidth: node.data.get('maxWidth'),
        src: node.data.get('src'),
        title: node.data.get('title'),
        href: node.data.get('href'),
        openExternal: node.data.get('openExternal')
      }
    }
  }

  setImageAttribute (event, value) {
    const imageAttributes = {
      ...this.state.imageAttributes,
      [event.target.name]: value
    }
    this.setState({
      imageAttributes: imageAttributes
    })
  }

  onKeyDown = (synthetic) => {
    // return
    if (synthetic.keyCode === 13) {
      this.onSubmit(synthetic)
    }
  }

  toggle = () => {
    this.props.changeModalState(!this.props.isOpen)
  }

  onCancel = () => {
    this.props.changeModalState(false)
  }

  onSubmit = e => {
    e.preventDefault()

    const { onChange, changeModalState } = this.props
    const attributes = {...this.state.imageAttributes}

    onChange(updateInlineImage({
      state: this.props.state,
      data: attributes
    }))
    changeModalState(false)
  }

  render () {
    let maxWidth = '200px'
    if (this.state.imageAttributes.maxWidth) {
      maxWidth = this.state.imageAttributes.maxWidth + 'px'
    }

    return (
      <Modal isOpen={this.props.isOpen} toggle={this.toggle}>
        <ModalHeader toggle={this.toggle}>Edit Image</ModalHeader>
        <ModalBody>
          <Form name='ImageForm' onKeyDown={this.onKeyDown}>

            <div>
              <a href={this.state.imageAttributes.src} target='_blank'>
                <img style={{maxWidth, marginBottom: '40px'}}
                  src={this.state.imageAttributes.src}
                  title={this.state.imageAttributes.title}
                  alt={this.state.imageAttributes.title} />
              </a>
            </div>

            <FormGroup>
              <Input type='text' name='title' id='Image-title'
                placeholder='Title of the image. (Appears on hover image)'
                onClick={e => e.stopPropagation()}
                onChange={e => this.setImageAttribute(e, e.target.value)}
                defaultValue={this.state.imageAttributes.title}
                 />
            </FormGroup>

            <FormGroup>
              <InputGroup>
                <InputGroupAddon>Max Width</InputGroupAddon>
                <Input type='number' name='maxWidth' id='Image-max-width'
                  placeholder='Max width in pixels'
                  onClick={e => e.stopPropagation()}
                  onChange={e => this.setImageAttribute(e, e.target.value)}
                  defaultValue={this.state.imageAttributes.maxWidth}
                   />
                <InputGroupAddon>pixels</InputGroupAddon>
              </InputGroup>
            </FormGroup>

            <hr />

            <FormGroup>
              <Input type='text' name='href' id='Image-href'
                placeholder='Ex. http://google.com (Clicking image redirects).'
                onClick={e => e.stopPropagation()}
                onChange={e => this.setImageAttribute(e, e.target.value)}
                defaultValue={this.state.imageAttributes.href}
                autoFocus
                 />
            </FormGroup>

            <FormGroup check>
              <Label check>
                <Input type='checkbox' name='openExternal'
                  onClick={e => e.stopPropagation()}
                  onChange={e => this.setImageAttribute(e, e.target.checked)}
                  checked={this.state.imageAttributes.openExternal}
                  />{' '}
                  Link opens in new window
              </Label>
            </FormGroup>

            {this.state.imageAttributes.fileId && <Link to={`/files/${this.state.imageAttributes.fileId}/replace`}>Replace image with new image</Link>}

          </Form>

          {false && <div className='debug-block'>
            state
            <pre>{JSON.stringify(this.state, null, 4)}</pre>
            props.presetData
            <pre>{JSON.stringify(this.props.presetData, null, 4)}</pre>
            props.node.data
            <pre>{JSON.stringify(this.props.node.get('data'), null, 4)}</pre>
          </div>}

        </ModalBody>
        <ModalFooter>
          <Button form='ImageForm' color='primary' type='submit' onClick={this.onSubmit}>Save</Button>{' '}
          <Button form='ImageForm' color='secondary' onClick={this.onCancel}>Cancel</Button>
        </ModalFooter>
      </Modal>
    )
  }
}

ImageModal.propTypes = {
  isOpen: PropTypes.bool,
  node: PropTypes.shape({
    data: PropTypes.shape({
      get: PropTypes.func.isRequired
    }),
    get: PropTypes.func.isRequired
  }),
  state: PropTypes.object.isRequired,
  changeModalState: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  presetData: PropTypes.shape({
    text: PropTypes.string
  })
}

export default ImageModal



// WEBPACK FOOTER //
// ./src/components/ImageSlatePlugin/ImageModal.js